import { Link } from 'react-router-dom';
import AdminTopbar from './AdminTopbar';

const SECTIONS = [
  { to: '/admin/submissions', label: 'Submissions',    desc: 'View and manage client setup form responses' },
  { to: '/admin/global',     label: 'Global / Brand',  desc: 'Site colours, logo, brand name' },
  { to: '/admin/navigation', label: 'Navigation',      desc: 'Menu links and CTA button' },
  { to: '/admin/hero',       label: 'Hero',            desc: 'Headline, subheading, hero CTA' },
  { to: '/admin/benefits',   label: 'Benefits',        desc: 'Benefit cards grid' },
  { to: '/admin/howitworks', label: 'How It Works',    desc: 'Step-by-step process section' },
  { to: '/admin/features',   label: 'Features',        desc: 'Feature list and channel tabs' },
  { to: '/admin/industries', label: 'Industries',      desc: 'Industry tab content' },
  { to: '/admin/pricing',    label: 'Pricing',         desc: 'Plans, FAQs, pricing copy' },
  { to: '/admin/faq',        label: 'FAQ',             desc: 'Frequently asked questions' },
  { to: '/admin/contact',    label: 'Contact',         desc: 'Contact details and form copy' },
  { to: '/admin/footer',     label: 'Footer',          desc: 'Footer links and legal text' },
];

export default function AdminDashboard() {
  return (
    <div className="adm-page">
      <AdminTopbar title="Dashboard" />

      <div className="adm-dashboard">
        <p className="adm-dashboard__intro">
          Select a section below to edit its content. Changes are saved to Firestore and go live immediately.
        </p>

        <div className="adm-dashboard__grid">
          {SECTIONS.map(({ to, label, desc }) => (
            <Link key={to} to={to} className="adm-dashboard__card">
              <span className="adm-dashboard__card-label">{label}</span>
              <span className="adm-dashboard__card-desc">{desc}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
